import { grey } from '@material-ui/core/colors'

export default {
  root: {
    backgroundColor: grey[50]
  }
}
